module.exports = __webpack_public_path__ + "img/15-fourImg.2f9691e2.png";